export default __webpack_public_path__ + "static/media/mint-content-bg-min.5e9e6e37.png";